import { fadeIn, fadeOut, clearPopup } from './helpers';

export default class Popup {
    constructor() {
        this.body = window.document.querySelector('body');
        this.html = window.document.querySelector('html');
    }

    /**
     * Open selected popup window
     *
     * @param {string} popupSelector - css selector of popup that should be opened
     * @param {number} timeOut - ms
     */
    openOnePopup(popupSelector = null, timeOut = 1000) {
        setTimeout(() => {
            this.body.classList.add('popup-opened');
            this.html.classList.add('popup-opened');
            fadeIn(popupSelector);
        }, timeOut);
    }

    /**
     * Force Close All opened popup window
     * and clear popup status
     */
    forceClosePopup() {
        fadeOut('.accessible-docs-popup');
        this.body.classList.remove('popup-opened');
        this.html.classList.remove('popup-opened');
        clearPopup();
    }

    /**
     * Closing popup window
     */
    closePopup() {
        this.body.addEventListener('click', (event) => {
            // Check if user click on close element
            if (![...event.target.classList].includes('js-popup-close')) {
                return false;
            }

            event.preventDefault();
            this.forceClosePopup();
            return true;
        });

        // Checking ESC button for closing opened popup window
        window.document.addEventListener('keydown', (event) => {
            if (event.keyCode === 27) {
                this.forceClosePopup();
            }
        });
    }

    init() {
        this.closePopup();
    }
}
